import React from 'react';
import { X, Check } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Student } from '../../types/batch';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { Button } from '../ui/button';

interface StudentSelectCardProps {
  student: any;
  isSelected: boolean;
  onToggle: (student: any) => void;
}

const StudentSelectCard: React.FC<StudentSelectCardProps> = ({
  student,
  isSelected,
  onToggle
}) => {
  const initials = (student?.studentsName || student?.name)
    .split(' ')
    .map(n => n?.charAt(0)) // Get the first character of each word  
    .join('')
    .substring(0, 2) // Take only the first two letters  
    .toUpperCase();
  return (
    <div
      className={cn(
        'flex items-center justify-between p-3 rounded-lg border border-gray-200 transition-colors cursor-pointer group hover:border-gray-300',
        isSelected && 'border-bytesplash-blue bg-bytesplash-soft-blue'
      )}
      onClick={() => onToggle(student)}
    >
      <div className="flex items-center space-x-3">
        <Avatar className="h-10 w-10">
          <AvatarImage src={student.avatar} alt={student.studentsName} />
          <AvatarFallback className="bg-bytesplash-blue text-white">
            {initials}
          </AvatarFallback>
        </Avatar>
        <div>
          <h4 className="text-sm font-medium text-gray-900">{student.studentsName}</h4>
          <p className="text-xs text-gray-500">{student.emailId}</p>
          {student.courseTaken && (
            <p className="text-xs text-gray-500 mt-0.5">{student.courseTaken}</p>
          )}
        </div>
      </div>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className={cn(
          'rounded-full h-8 w-8 opacity-0 group-hover:opacity-100 transition-opacity',
          isSelected && 'opacity-100 text-bytesplash-blue bg-white hover:bg-white hover:text-bytesplash-blue'
        )}
        onClick={(e) => {
          e.stopPropagation();
          onToggle(student);
        }}
      >
        {isSelected ? <Check className="h-4 w-4" /> : <X className="h-4 w-4" />}
      </Button>
    </div>
  );
};

export default StudentSelectCard;
